module.exports = __webpack_public_path__ + "BHALogo-f0e6236a163f722c825b23d086d6163f.svg";